import { Fields } from '../../../../constants';
import { TextField } from '../../TextField';

export const CardHolderField = () => <TextField name={Fields.CARDHOLDER_NAME} />;
